module.exports = __webpack_public_path__ + "static/zahn-3b3ea886bffa6b04cb0ed3474059eb6f.jpg";